<div class="updater-content">
  <span class="title-text">Доступно обновление.</span>
  <button app-flat-button class="update-btn" color="primary" size="small" type="button" (click)="update()">
    Обновить
  </button>
  <button app-icon-button class="close-btn" type="button" (click)="close()">
    <svg-icon src="close-icon"></svg-icon>
  </button>
</div>
